/**
 * EO «Конфигуратор → Филиалы»: ячейка «Учебный пакет» (28.09, «Юниверситет»).
 * Какой филиал что показывает во вкладке оператора — настройка филиала, как
 * mc_shift: «Никаких сравнений с id или именем филиала в коде». Белый список —
 * один на API и интерфейс (UNI_PACKS из @ub/shared/uni); неизвестное → 400.
 */
import { useState } from "react";
import { UNI_PACKS } from "@ub/shared/uni";
import { Dropdown } from "../../components/shared";
import css from "./config.module.css";

export function UniPackPick({ value, flash, onPick }: {
  value: string;
  /** flashOk «✓» этой ячейки (useBranchConfig.flash, если ключ совпал). */
  flash: { key: string; n: number } | null;
  onPick: (id: string) => void;
}) {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const label = UNI_PACKS.find((p) => p.id === value)?.label ?? (value || "Нет");
  return (
    <>
      <button
        key={flash ? `f${flash.n}` : "s"}
        type="button"
        className={`${css.editv} ${flash ? css.flash : ""}`}
        onClick={(e) => setAnchor(e.currentTarget)}
      >
        {label} ▾
      </button>
      <Dropdown
        open={!!anchor}
        anchor={anchor}
        title="Учебный пакет"
        multi={false}
        filter={false}
        items={UNI_PACKS.map((p) => ({ id: p.id, label: p.label }))}
        selectedIds={[value]}
        onCommit={(ids) => { if (ids.length) onPick(String(ids[0])); }}
        onClose={() => setAnchor(null)}
      />
    </>
  );
}
